export const APPT_TYPES = [
  "Sportello", "Sopralluogo", "Telefonata", "Azienda", "Fotovoltaico",
  "Climatizzazione", "Caldaia", "Wallbox", "Commodity", "Altro",
];

export const APPT_STATUS = [
  "Programmato", "Confermato", "Completato", "Rimandato", "Annullato", "Non presentato",
];

// Badge type -> sempre testo + colore (mai solo colore)
export function statusTone(status) {
  switch (status) {
    case "Confermato": return "info";
    case "Completato": return "success";
    case "Rimandato": return "warning";
    case "Annullato": return "neutral";
    case "Non presentato": return "danger";
    default: return "pending"; // Programmato
  }
}

// Colore di sfondo del chip in calendario (complementare al testo scuro)
export function statusChip(status) {
  switch (status) {
    case "Confermato": return "bg-brand/10 text-brand";
    case "Completato": return "bg-success/15 text-success";
    case "Rimandato": return "bg-warning/15 text-warning";
    case "Annullato": return "bg-slate-100 text-slate-400 line-through";
    case "Non presentato": return "bg-danger/10 text-danger";
    default: return "bg-slate-100 text-slate-700"; // Programmato
  }
}

export const REMINDER_OPTIONS = [
  { value: "", label: "Nessun promemoria" },
  { value: "30", label: "30 minuti prima" },
  { value: "120", label: "2 ore prima" },
  { value: "1440", label: "24 ore prima" },
  { value: "custom", label: "Personalizzato…" },
];
